export default "__VITE_ASSET__ByxfzC5j__"